import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {StoreService} from "../../services/store.service";
import {Category} from "../../../interfaces/category";
import {MainDataService} from '../../services/main-data.service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AppDataService} from "../../services/app-data.service";
import {environment} from 'src/environments/environment';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, AfterViewInit {
  categories: Array<Category> = [];
  @ViewChild('widgetsContent') widgetsContent!: ElementRef;
  isShowSlider: boolean = environment.isStoreCloud
  ShowCategory;
  leftArrow: boolean = true;
  rightArrow: boolean = true;
  isShop: boolean = false;
  link = 'link';
  isStoreCloud: boolean = environment.isStoreCloud;
  items: any[] = [
    {title: 'Orangies', link: 'https://www.github.com/isahohieku'},
    {title: 'Apple', link: 'https://www.github.com/isahohieku'},
    {title: 'Mango', link: 'https://www.github.com/isahohieku'},
    {title: 'Carrot', link: 'https://www.github.com/isahohieku'}
  ];

  constructor(
    private store: StoreService,
    private translate: TranslateService,
    private mainDataService: MainDataService,
    private messageService: MessageService,
    private appDataService: AppDataService
  ) {
    this.ShowCategory = false;
  }

  ngOnInit(): void {
    this.getMainData();
  }

  scrollLeft() {
    this.widgetsContent.nativeElement.scrollLeft -= 150;
    if (this.widgetsContent.nativeElement.scrollLeft == 0 || this.widgetsContent.nativeElement.scrollLeft < 250) {
      this.leftArrow = true;
    } else {
      this.leftArrow = false;
    }
    this.rightArrow = true;
  }

  scrollRight() {
    this.widgetsContent.nativeElement.scrollLeft += 150;
    this.leftArrow = false;
    if (this.widgetsContent.nativeElement.scrollLeft > 0) {
      this.leftArrow = false;
    }


  }

  ngAfterViewInit(): void {
    setTimeout(() => {

      this.store.subscription('categories')
        .subscribe({
          next: (res: any) => {
            this.categories = res;


          },
          error: (err: any) => {
            console.error(err);
          }
        });
    }, 1);
  }

  getMainData(): void {
    const initialData = this.appDataService.initialData
    this.isShop = initialData.isShop;
    this.store.set("isShop", this.isShop);
  }

}
